import React, { Fragment, type FunctionComponent, useEffect } from 'react'
import { PickupAnalyticsFilters } from 'domains/reports/components/pickup-analytics/PickupAnalyticsFilters'
import { usePickupAnalyticsBehaviour } from 'domains/reports/components/pickup-analytics/utils/pickupAnalytics.hooks'
import { PickupAnalyticsContent } from 'domains/reports/components/pickup-analytics/PickupAnalyticsContent'
import { usePickupAnalyticsTour } from 'domains/pickup-settings/training-tour/pickupAnalyticsTourSteps'
import { RestartTourFooter } from 'domains/pickup-settings/training-tour/RestartTourFooter'
import { useNavContext } from 'gin-and-tonic/containers/nav/utils/NavContext'
import { usePickupTourStatus } from 'domains/pickup-settings/training-tour/usePickupTourStatus'
interface Props {}

export const PickupAnalytics: FunctionComponent<Props> = () => {
  const { isBlockedByModal } = useNavContext()
  const pickupAnalyticsBehaviour = usePickupAnalyticsBehaviour()
  const isPageReady =
    !pickupAnalyticsBehaviour.isLoading && !pickupAnalyticsBehaviour.error && !isBlockedByModal
  const { startTour, redoTour } = usePickupAnalyticsTour()
  const { isTourCompleted, isTourPending } = usePickupTourStatus('pickup_analytics')

  useEffect(() => {
    // if (isPageReady && isTourPending) startTour()
  }, [isPageReady, startTour, isTourPending])

  return (
    <Fragment>
      <PickupAnalyticsFilters {...pickupAnalyticsBehaviour} />
      <PickupAnalyticsContent {...pickupAnalyticsBehaviour} />
      <div
        css={{
          position: 'absolute',
          top: '95%',
          left: '60%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {(isTourCompleted || isTourPending) && <RestartTourFooter onRedoTour={redoTour} />}
      </div>
    </Fragment>
  )
}
